import { Navigate, Outlet } from 'react-router-dom';
import { getParticipantSession } from '@/features/participant/participant.storage';

export function RequireParticipant() {
  const participant = getParticipantSession();

  if (!participant) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
